import { forwardRef } from 'react';
import { Input } from '../../ui';

/** Campo per il codice a 6 cifre: tastiera numerica e suggerimento automatico dell'iPhone. */
export const CodeInput = forwardRef<
  HTMLInputElement,
  {
    value: string;
    onChange: (v: string) => void;
    id?: string;
    invalid?: boolean;
    describedBy?: string;
    autoFocus?: boolean;
  }
>(function CodeInput({ value, onChange, id, invalid, describedBy, autoFocus }, ref) {
  return (
    <Input
      ref={ref}
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]*"
      maxLength={6}
      placeholder="000000"
      autoFocus={autoFocus}
      invalid={invalid}
      aria-describedby={describedBy}
      className="tabular h-14 text-center text-2xl tracking-[0.4em]"
    />
  );
});
